
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 46.771 46.771\" id=\"icon-location\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M23.387,0C10.47,0,0,10.47,0,23.386s10.47,23.386,23.386,23.386c12.915,0,23.385-10.47,23.385-23.386\r\n\tS36.302,0,23.387,0 M22.802,39.061c0,0.442-0.315,0.794-0.728,0.889V25.627c0.001-0.515-0.416-0.931-0.929-0.931H6.822\r\n\tc0.094-0.413,0.447-0.727,0.889-0.727l27.309-13.148c0.513,0,0.929,0.417,0.929,0.93L22.802,39.061z\"/> </symbol>";
module.exports = sprite.add(image, "icon-location");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/location.svg
 ** module id = 196
 ** module chunks = 24
 **/